<script>
	import { onDestroy } from 'svelte';
	import { timeRemaining } from 'cando-util';

	export let start;
	export let end = false;
	export let cls = 'text-green-500';
	export let format = 'h m s';

	let intervalId = null;

	$: duration = timeRemaining(new Date(start), new Date(end || new Date()), format);

	$: isRunning = !end;

	$: (() => {
		if (isRunning) {
			if (!intervalId) {
				intervalId = setInterval(() => {
					duration = timeRemaining(new Date(start), new Date(end || new Date()), format);
				}, 1000);

				console.log(`setting intervalId ${intervalId}`);
			}
		} else {
			if (intervalId) {
				console.log(`clearing intervalId ${intervalId}`);

				clearInterval(intervalId);

				intervalId = null;
			}
		}
	})();

	onDestroy(async () => {
		if (intervalId) {
			console.log(`clearing intervalId ${intervalId}`);

			clearInterval(intervalId);

			intervalId = 0;
		}
	});
</script>

{#if duration}
	<div class={`ml-1 ${cls}`}>
		{duration}
	</div>
{/if}
